// extracted by mini-css-extract-plugin
export default {"Spinner":"A4AHfBE6","spin":"O_bLYa6l"};